import React from 'react';

const MarketPanelSummary = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Summary</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white">
            <tbody>
              <tr>
                <td>US Market Summary</td>
                <td id="us-summary">{data?.us_market_summary || 'No summary available'}</td>
              </tr>
              <tr>
                <td>Asian Market Summary</td>
                <td id="asian-summary">{data?.asian_market_summary || 'No summary available'}</td>
              </tr>
              <tr>
                <td>European Market Summary</td>
                <td id="european-summary">{data?.european_market_summary || 'No summary available'}</td>
              </tr>
              <tr>
                <td>Global Market Summary</td>
                <td id="global-summary">{data?.global_summary || 'No summary available'}</td>
              </tr>
              <tr>
                <td>Sensex Summary</td>
                <td id="sensex-summary">{data?.sensex || 'No summary available'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelSummary; 